import { ICampaignJoinRequestUseCase,CampaignJoinRequestResponse ,CampaignJoinRequestPayload } from '../../interfaces';
import { HttpPostRequest } from '@infrastructure/axios/http-post-request';
import BackendResponse from '@core/shared/backend-response';

export default class CampaignJoinRequestUseCase extends HttpPostRequest<CampaignJoinRequestPayload ,CampaignJoinRequestResponse > implements ICampaignJoinRequestUseCase{

 public async execute(payload: CampaignJoinRequestPayload ): Promise<BackendResponse<CampaignJoinRequestResponse >> {
    const response = await this.dispatch('/campaign/request-to-join', payload);
    return (response.data);
}
}
